import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { PhotoGallery } from './EvidencePhotos';
export function DeepCleanHistoryPanel({ api, propertyId }) {
    const [summary, setSummary] = useState(), [entries, setEntries] = useState([]);
    const [cursor, setCursor] = useState(), [error, setError] = useState(''), [busy, setBusy] = useState(false);
    useEffect(() => {
        const abort = new AbortController();
        setBusy(true);
        void Promise.all([api(`/properties/${propertyId}/deep-clean/summary`, 'GET', undefined, abort.signal),
            api(`/properties/${propertyId}/deep-clean/history`, 'GET', undefined, abort.signal)])
            .then(([summary, page]) => { if (!abort.signal.aborted) {
            setSummary(summary);
            setEntries(page.items);
            setCursor(page.next_cursor);
        } })
            .catch(e => { if (!abort.signal.aborted)
            setError(e.message); }).finally(() => { if (!abort.signal.aborted)
            setBusy(false); });
        return () => abort.abort();
    }, [api, propertyId]);
    async function more() {
        if (!cursor || busy)
            return;
        setBusy(true);
        setError('');
        try {
            const page = await api(`/properties/${propertyId}/deep-clean/history?before=${cursor}`);
            setEntries(current => [...current, ...page.items]);
            setCursor(page.next_cursor);
        }
        catch (e) {
            setError(e instanceof Error ? e.message : 'Unable to load history');
        }
        finally {
            setBusy(false);
        }
    }
    async function download(kind) {
        if (busy)
            return;
        setBusy(true);
        setError('');
        try {
            const file = await api(`/deep-clean/export?property_ids=${propertyId}&kind=${kind}`);
            const url = URL.createObjectURL(new Blob([file.content], { type: file.content_type }));
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = file.filename;
            anchor.click();
            setTimeout(() => URL.revokeObjectURL(url), 1000);
        }
        catch (e) {
            setError(e instanceof Error ? e.message : 'Unable to export');
        }
        finally {
            setBusy(false);
        }
    }
    return _jsxs("section", { "aria-label": "Deep clean history", children: [error ? _jsx("p", { role: "alert", children: error }) : null, busy ? _jsx("p", { role: "status", children: "Loading\u2026" }) : null, summary ? _jsxs(_Fragment, { children: [_jsxs("p", { children: [summary.address, " \u00B7 ", summary.needs_deep_clean ? 'Unresolved deep clean needs' : 'No unresolved deep clean Reports'] }), _jsxs("div", { className: "work-actions", children: [_jsx("button", { disabled: busy, onClick: () => void download('summary'), children: "Export summary CSV" }), _jsx("button", { disabled: busy, onClick: () => void download('details'), children: "Export full details CSV" })] }), _jsx("div", { style: { overflowX: 'auto' }, children: _jsxs("table", { children: [_jsx("caption", { children: "Actual completion by item" }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Item" }), _jsx("th", { children: "Outstanding Reports" }), _jsx("th", { children: "Last completed" }), _jsx("th", { children: "Completed by" })] }) }), _jsx("tbody", { children: summary.items.map(item => _jsxs("tr", { children: [_jsx("td", { children: item.label }), _jsx("td", { children: item.outstanding_reports }), _jsx("td", { children: item.last_completed_at ? new Date(item.last_completed_at).toLocaleString() : 'No record' }), _jsx("td", { children: item.last_completed_by_name || item.last_completed_by || '—' })] }, item.item_code)) })] }) })] }) : null, _jsx("h4", { children: "Full execution history" }), _jsx("p", { children: "Scheduled work has no completion date until the item is completed." }), entries.map(entry => _jsx(HistoryEntry, { entry: entry, api: api }, entry.id)), !busy && !entries.length ? _jsx("p", { children: "No execution records." }) : null, cursor ? _jsx("button", { disabled: busy, onClick: () => void more(), children: "Load older execution records" }) : null] });
}
function HistoryEntry({ entry, api }) {
    const [open, setOpen] = useState(false), [photos, setPhotos] = useState([]), [error, setError] = useState('');
    useEffect(() => {
        if (!open || !entry.photo_ids.length)
            return;
        const abort = new AbortController();
        void api(`/tasks/${entry.job_id}/photos`, 'GET', undefined, abort.signal)
            .then(photos => { if (!abort.signal.aborted)
            setPhotos(photos.filter(photo => entry.photo_ids.includes(photo.id))); })
            .catch(e => { if (!abort.signal.aborted)
            setError(e.message); });
        return () => abort.abort();
    }, [api, entry, open]);
    return _jsxs("details", { className: "work-card", onToggle: event => setOpen(event.currentTarget.open), children: [_jsxs("summary", { children: [entry.description, " \u00B7 ", entry.status, " \u00B7 ", entry.completed_at ? new Date(entry.completed_at).toLocaleString() : 'No completion recorded'] }), _jsxs("p", { children: ["Task ", entry.cos_job_id, " \u00B7 ", entry.completed_by_name || entry.completed_by || 'No completion recorded'] }), entry.report_id ? _jsxs("p", { children: ["Report ", entry.report_id] }) : _jsx("p", { children: "Preventive task" }), entry.note ? _jsx("p", { children: entry.note }) : null, error ? _jsx("p", { role: "alert", children: error }) : null, open ? _jsx(PhotoGallery, { photos: photos }) : null] });
}
